import { ClassNames } from '../utils/ClassNames';
import { BsArrowUpRight } from 'react-icons/bs';


const OverviewCard = ({ img, title, amount, percent, icon, bgColor, date }) => {
  return (
    <div className={`${ClassNames(bgColor === "red" ? "bg-[#FF0000] text-white": "bg-white text-black")} mt-2 rounded-md px-4 py-5`}>
            <div className="flex items-center">
              <div className="rounded-full p-2 mr-2 bg-[#F5F7F9]">
                <p className='text-2xl text-primaryRed'>{img}</p>
              </div>
              <p className="text-sm">{title}</p>
            </div>
            <p className="text-3xl font-bold my-3">{amount}</p>
            <div className="flex items-center">
                <div className="flex items-center">
                    { icon === "icon" ? <BsArrowUpRight className='text-green-600 text-md' />: '' }
                  <p className="text-xs pl-2">{percent} /</p>
                  <p className="text-xs text-[#83879B]"> {date}</p>
                </div>
            </div>
    </div>
  )
}

export default OverviewCard